import { Editor } from '../core/Editor';
import { HistoryStep } from '../types';
import { Icons } from './Icons';

export class HistoryPanel {
  private editor: Editor;
  private container: HTMLElement;

  constructor(editor: Editor, container: HTMLElement) {
    this.editor = editor;
    this.container = container;
  }

  public render(steps: HistoryStep[], activeIndex: number) {
    this.container.innerHTML = `
      <div class="panel-card history-card">
        <div class="panel-header">
          <div class="panel-title">
            ${Icons.undo}
            <span>History</span>
          </div>
          <div class="panel-header-actions">
            <button class="icon-btn-mini" id="btn-undo-step" title="Undo (Ctrl+Z)" ${activeIndex <= 0 ? 'disabled' : ''}>
              ${Icons.undo}
            </button>
            <button class="icon-btn-mini" id="btn-redo-step" title="Redo (Ctrl+Y)" ${activeIndex >= steps.length - 1 ? 'disabled' : ''}>
              ${Icons.redo}
            </button>
          </div>
        </div>

        <div class="history-list-scroll">
          ${steps
            .map((step, idx) => {
              const isActive = idx === activeIndex;
              const isFuture = idx > activeIndex;
              return `
              <div class="history-item ${isActive ? 'active' : ''} ${isFuture ? 'future' : ''}" data-index="${idx}">
                <span class="hist-icon">${Icons.sparkles}</span>
                <span class="hist-name">${step.name}</span>
                ${isActive ? '<span class="hist-current-tag">Current</span>' : ''}
              </div>
            `;
            })
            .join('')}
        </div>
      </div>
    `;

    // Events
    this.container.querySelectorAll('.history-item').forEach(item => {
      item.addEventListener('click', () => {
        const idx = parseInt((item as HTMLElement).dataset.index || '-1');
        if (idx >= 0) {
          this.editor.historyJump(idx);
        }
      });
    });

    this.container.querySelector('#btn-undo-step')?.addEventListener('click', () => {
      this.editor.undo();
    });

    this.container.querySelector('#btn-redo-step')?.addEventListener('click', () => {
      this.editor.redo();
    });
  }
}
